import { Carousel } from "antd";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import React, { useMemo, useRef, useState } from "react";
import ButtonGroup from "../../../../components/buttonGroup";

import "./ContestCard.css";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

const locale = require("react-redux-i18n").I18n;

const Tag = ({ status }) => {
  if (status === "ended") {
    return (
      <div style={{ position: "absolute", top: 0, padding: "14px" }}>
        <div
          style={{
            color: "#2F2F2F",
            fontSize: "12px",
            backgroundColor: "#F9F9F9",
            padding: "4px 8px",
            borderRadius: "24px",
          }}
        >
          {locale.t("cardContest.status.ended")}
        </div>
      </div>
    );
  }

  if (status === "opening" || status === "upcoming") {
    return (
      <div style={{ position: "absolute", top: 0, padding: "14px" }}>
        <div
          style={{
            color: status === "opening" ? "#1CB894" : "#9D821F",
            fontSize: "12px",
            backgroundColor: status === "opening" ? "#F1FEFA" : "#FFF8D0",
            padding: "4px 8px",
            borderRadius: "24px",
          }}
        >
          {status === "opening"
            ? locale.t("cardContest.status.opening")
            : locale.t("cardContest.status.upcoming")}
        </div>
      </div>
    );
  }

  return null;
};

const Time = ({ date }) => {
  const [countdown, setCountdown] = React.useState({
    days: "00",
    hours: "00",
    minutes: "00",
    seconds: "00",
  });

  React.useEffect(() => {
    const targetDate = new Date(date);
    let isMounted = true;
    let timer;

    const updateCountdown = () => {
      const now = new Date();
      const difference = targetDate - now;

      if (difference > 0) {
        const days = Math.floor(difference / (1000 * 60 * 60 * 24));
        const hours = Math.floor(
          (difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
        );
        const minutes = Math.floor(
          (difference % (1000 * 60 * 60)) / (1000 * 60)
        );
        const seconds = Math.floor((difference % (1000 * 60)) / 1000);

        if (isMounted) {
          setCountdown({
            days: days < 10 ? `0${days}` : `${days}`,
            hours: hours < 10 ? `0${hours}` : `${hours}`,
            minutes: minutes < 10 ? `0${minutes}` : `${minutes}`,
            seconds: seconds < 10 ? `0${seconds}` : `${seconds}`,
          });
        }
      } else if (isMounted) {
        clearInterval(timer);
      }
    };

    updateCountdown();
    timer = setInterval(updateCountdown, 1000);

    return () => {
      isMounted = false;
      clearInterval(timer);
    };
  }, [date]);

  return (
    <div
      style={{
        padding: "10px 30px",
        backgroundColor: "#F9F9F9",
        borderRadius: "8px",
        height: "72px",
      }}
    >
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(7, 1fr)",
          gridTemplateRows: "repeat(2, 1fr)",
          gap: "4px",
          textAlign: "center",
        }}
      >
        <div style={{ fontWeight: "800", fontSize: "20px" }}>
          {countdown.days}
        </div>
        <div style={{ fontWeight: "800", fontSize: "20px" }}>:</div>
        <div style={{ fontWeight: "800", fontSize: "20px" }}>
          {countdown.hours}
        </div>
        <div style={{ fontWeight: "800", fontSize: "20px" }}>:</div>
        <div style={{ fontWeight: "800", fontSize: "20px" }}>
          {countdown.minutes}
        </div>
        <div style={{ fontWeight: "800", fontSize: "20px" }}>:</div>
        <div style={{ fontWeight: "800", fontSize: "20px" }}>
          {countdown.seconds}
        </div>
        <div style={{ color: "#A3A3A3", fontSize: "12px" }}>days</div>
        <div></div>
        <div style={{ color: "#A3A3A3", fontSize: "12px" }}>hrs</div>
        <div></div>
        <div style={{ color: "#A3A3A3", fontSize: "12px" }}>mins</div>
        <div></div>
        <div style={{ color: "#A3A3A3", fontSize: "12px" }}>sec</div>
      </div>
    </div>
  );
};

const ContestCard = ({ data, size, userStatus, accountNumber, fetchContestMe }) => {
  const refImage = useRef();
  const location = useLocation();
  const user = useSelector((state) => state.user);

  const [index, setIndex] = useState(0);

  const [active, setActive] = useState(false);

  const accountID = useMemo(() => {
    return user?.accounts
      ?.filter((e) => data?.id === e.account_trade_participant?.contest_id)
      .map((e) => e?.account_number);
  }, [user, data]);

  const afterChangeHandler = (index) => {
    setIndex(index);
    setActive(false);
  };

  const handleNext = () => {
    setActive(true);
    refImage.current.next();
  };

  const handlePrev = () => {
    setActive(true);
    refImage.current.prev();
  };

  return size === "vertical" ? (
    <div
      style={{
        border: "1px solid #D9D9D9",
        width: "100%",
        borderRadius: "12px",
        overflow: "hidden",
        margin: "auto",
        height: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div
        style={{ position: "relative", height: "257px", overflow: "hidden" }}
      >
        <Carousel
          ref={refImage}
          style={{ position: "relative", height: "257px" }}
          dots={false}
          afterChange={afterChangeHandler}
          autoplay={true}
          autoplaySpeed={3000}
        >
          {data.rewards?.length > 0 ? (
            data.rewards?.map((item, index) => {
              return (
                <div key={index} style={{ height: "257px", width: "100%" }}>
                  <img
                    src={process.env.REACT_APP_SYMBOL + item.picture}
                    style={{
                      width: "100%",
                      height: "257px",
                      objectFit: "cover",
                      backgroundColor: "#f0f0f0",
                    }}
                    alt={data.name || "Contest image"}
                  />
                </div>
              );
            })
          ) : (
            <div style={{ height: "257px", width: "100%" }}>
              <div
                style={{
                  width: "100%",
                  height: "100%",
                  backgroundColor: "#f0f0f0",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#999",
                }}
              >
                No Image Available
              </div>
            </div>
          )}
        </Carousel>
        <Tag status={data.status} />
        <div
          style={{
            background:
              "linear-gradient(to bottom, rgba(0,0,0,0), rgba(0,0,0,0.8))",
            width: "100%",
            padding: "16px",
            position: "absolute",
            bottom: 0,
          }}
        >
          <div
            style={{
              color: "white",
              fontSize: "18px",
              fontWeight: 800,
              maxWidth: "100%",
              overflow: "hidden",
              display: "-webkit-box",
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical",
              textOverflow: "ellipsis",
            }}
          >
            {data.name}
          </div>
        </div>
      { data.rewards?.length > 1 && <div
          className="d-flex justify-content-between"
          style={{
            width: "100%",
            top: "50%",
            zIndex: 99,
            position: "absolute",
            padding: "0 14px",
          }}
        >
          <div
            style={{
              backgroundColor: "rgba(30, 30, 30, 0.5)",
              borderRadius: "50%",
              width: "24px",
              height: "24px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <IoIosArrowBack
              onClick={!active && handlePrev}
              style={{ fontSize: "20px", color: "white" }}
              className="cursor-pointer"
            />
          </div>
          <div
            style={{
              backgroundColor: "rgba(30, 30, 30, 0.5)",
              borderRadius: "50%",
              width: "24px",
              height: "24px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <IoIosArrowForward
              onClick={!active && handleNext}
              style={{ fontSize: "20px", color: "white" }}
              className="cursor-pointer"
            />
          </div>
        </div>}
      </div>
      <div
        style={{
          padding: "24px",
          display: "flex",
          flexDirection: "column",
          flexGrow: 1,
          justifyContent: "space-between",
        }}
      >
        <div>
          <div style={{ fontSize: "14px", color: "#1E1E1E" }}>
            {locale.t("cardContest.date")}:{" "}
            <span style={{ fontWeight: "800" }}>
              {new Date(data.from)
                .toLocaleDateString("en-GB", {
                  year: "numeric",
                  month: "2-digit",
                  day: "2-digit",
                })
                .replace(/\//g, "/")}{" "}
              -{" "}
              {new Date(data.to)
                .toLocaleDateString("en-GB", {
                  year: "numeric",
                  month: "2-digit",
                  day: "2-digit",
                })
                .replace(/\//g, "/")}
            </span>
          </div>
          <div
            style={{
              paddingTop: "12px",
              marginBottom: "12px",
              fontSize: "14px",
              color: "#1E1E1E",
            }}
          >
            {locale.t("cardContest.participant")}:{" "}
            <span style={{ fontWeight: "800" }}>
              {data.status === "upcoming" || data.participant_count === 0 ? "-" : data.participant_count}
            </span>
          </div>
        </div>

        <div style={{ marginTop: "auto" }}>
          {data.status !== "ended" && (
            <div style={{ marginBottom: "16px" }}>
              <Time date={data.status === "upcoming" ? data.from : data.to} />
            </div>
          )}
          <div>
            <ButtonGroup
              status={data.status}
              requirement={data.requirement}
              condition={data.condition}
              contestId={data.id}
              accountID={accountID}
              accountNumber={accountNumber}
              location={location}
              disable={data.participant !== null}
            />
          </div>
        </div>
      </div>
    </div>
  ) : (
    <div
      className="border d-flex flex-column flex-md-row"
      style={{
        borderRadius: "12px",
        marginTop: "24px",
        overflow: "hidden",
      }}
    >
      <div
        className="contest-cards"
        style={{
          position: "relative",
          // maxWidth: "344px",
          // minWidth: "287px",
        }}
      >
        <Carousel
          ref={refImage}
          style={{
            position: "relative",
          }}
          dots={false}
          afterChange={afterChangeHandler}
          autoplay={true}
          autoplaySpeed={3000}
        >
          {data.rewards?.map((item, index) => (
            <img
              src={process.env.REACT_APP_SYMBOL + item.picture}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
              }}
              alt=""
            />
          ))}
        </Carousel>
        <Tag status={data.status} />
        <div
          style={{
            background:
              "linear-gradient(to bottom, rgba(0,0,0,0), rgba(0,0,0,0.8))",
            width: "100%",
            padding: "16px",
            position: "absolute",
            bottom: 0,
            textAlign: "center",
          }}
        >
          <div
            style={{
              color: "#D9D9D9",
              margin: "auto",
              display: "inline-block",
              padding: "4px",
              backgroundColor: "#696969",
              borderRadius: "6px",
            }}
          >
            {index + 1} / {data.rewards?.length}
          </div>
        </div>
       {data.rewards?.length > 1 && <div
          className="d-flex justify-content-between"
          style={{
            width: "100%",
            top: "50%",
            transform: "translateY(-50%)",
            zIndex: 99,
            position: "absolute",
            padding: "0 14px",
          }}
        >
          <div
            style={{
              backgroundColor: "rgba(30, 30, 30, 0.5)",
              borderRadius: "50%",
              width: "24px",
              height: "24px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
            }}
          >
            <IoIosArrowBack
              onClick={!active && handlePrev}
              style={{ fontSize: "20px", color: "white" }}
            />
          </div>
          <div
            style={{
              backgroundColor: "rgba(30, 30, 30, 0.5)",
              borderRadius: "50%",
              width: "24px",
              height: "24px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
            }}
          >
            <IoIosArrowForward
              onClick={!active && handleNext}
              style={{ fontSize: "20px", color: "white" }}
            />
          </div>
        </div>}
      </div>
      <div
        style={{
          padding: "24px",
          display: "flex",
          justifyContent: "space-between",
          flexDirection: "column",
          gap: "16px",
          flexGrow: 1,
        }}
      >
        <div>
          <div
            style={{
              fontSize: "20px",
              fontWeight: "800",
              overflow: "hidden",
              display: "-webkit-box",
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical",
              textOverflow: "ellipsis",
            }}
          >
            {data.name}
          </div>
          <div style={{ marginTop: "14px", fontSize: "14px" }}>
            {locale.t("cardContest.date")}:{" "}
            <span style={{ fontWeight: "800" }}>
              {new Date(data.from)
                .toLocaleDateString("en-GB", {
                  year: "numeric",
                  month: "2-digit",
                  day: "2-digit",
                })
                .replace(/\//g, "/")}{" "}
              -{" "}
              {new Date(data.to)
                .toLocaleDateString("en-GB", {
                  year: "numeric",
                  month: "2-digit",
                  day: "2-digit",
                })
                .replace(/\//g, "/")}
            </span>
          </div>
          <div
            style={{
              marginTop: "12px",
              marginBottom: "12px",
              fontSize: "14px",
            }}
          >
            {locale.t("cardContest.participant")}:{" "}
            <span style={{ fontWeight: "800" }}>
              {data.status === "upcoming" ? "-" : data.participant_count}
            </span>
          </div>
        </div>
        {data.status !== "ended" && (
          <div className="contest-cards-time">
            <Time date={data.status === 'upcoming' ? data?.from : data?.to} />
          </div>
        )}
        <div className="contest-cards-time">
          <ButtonGroup
            status={data.status}
            requirement={data.requirement}
            condition={data.condition}
            size="horizontal"
            contestId={data.id}
            accountID={accountID}
            accountNumber={accountNumber}
            disable={data.participant !== null}
            userStatus={userStatus}
            fetchContestMe={fetchContestMe}
          />
        </div>
      </div>
    </div>
  );
};

export default ContestCard;
